import React, { useEffect } from 'react';
import { Box, TextField, Button } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = (props) => {
  const { query, handleRestClick, handleSearch } = props;
  const { depName } = query;
  //查询参数
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: { depName },
  });
  useEffect(() => {
    if (depName) {
      setValue('depName', depName);
    }
  }, [depName, setValue]);

  //重置
  const handleReset = () => {
    setValue('depName', '');

    handleRestClick({
      depName: '',
    });
  };
  return (
    <SearchGroupStyled>
      <form
        onSubmit={handleSubmit((values) => {
          handleSearch(values);
        })}
      >
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="first-line">
              <Controller
                render={(rp) => (
                  <TextField
                    name="depName"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label="部门名称"
                    value={rp.value}
                    defaultValue={''}
                    onChange={(e) => {
                      setValue('depName', e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('depName', '');
                            }}
                            edge="end"
                          >
                            {rp.value ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="depName"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="部门名称"
              />
              <div></div>
              <div></div>
              <div></div>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleReset}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>

            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
